export default __webpack_public_path__ + "assets/images/pricing/2e2bc88e1a2ca0b9260bb42c6455a3e1.png";